import { HomePage } from 'components/pages/Home'

export default () => <HomePage withPartner />
